// removed by extract-text-webpack-plugin
module.exports = {"List":"_3DiKNSlGaO7jN4kS5NnZ1o","Header":"EyAFqqCZaEqCTK489fFJx","green":"_1h8VnBnEZkKee7_pT7utx3","red":"_1z95nO1e9bs_LoyCB03PLM","Row":"hflpkZE6Vtx03ljbZ-as3"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/BreakReportList/index.css
// module id = 938
// module chunks = 0